import {
  CheckNotes,
  InspectionCase,
  InspectionCaseDto,
  SummaryNotes
} from '../inspection-cases';
import { Cases, Inspection } from '../inspection.dto';
import { SubCases } from '../sub-cases.dto';
import { airConditioningAndVentilationInspectionCases } from './cases-data';

export class InspectionAirConditioningAndVentilationSystemsDto extends InspectionCase {
  cases?: SubCases[] = [];

  summaryNotes?: SummaryNotes[];
}

export class InspectionAirConditioningAndVentilationSystems
  extends InspectionAirConditioningAndVentilationSystemsDto
  implements Inspection
{
  constructor(
    data: InspectionAirConditioningAndVentilationSystemsDto = {
      title: 'בדיקת התאמה למערכות מיזוג אוויר ואוורור',
      isTitle: true,
      isApplicable: true,
      summaryNotes: [],
      cases: []
    }
  ) {
    super(data);

    const casesMap: Map<string, InspectionCaseDto> = new Map();
    data.cases.forEach((c) => casesMap.set(c.section, c));
    data.cases
      .map((c) => c.subCases)
      .flat()
      .forEach((c) => casesMap.set(c.section, c));

    airConditioningAndVentilationInspectionCases.forEach((x) => {
      const subCases = x.subCases.map(
        (subCase) =>
          new InspectionCase({
            ...casesMap.get(subCase.section),
            title: subCase.title,
            isTitle: subCase.isTitle,
            section: subCase.section
          })
      );

      const item: SubCases = new InspectionCase({
        ...casesMap.get(x.section),
        title: x.title,
        isTitle: x.isTitle,
        section: x.section
      });

      item.subCases = subCases;

      this.cases.push(item);
    });

    this.summaryNotes = data.summaryNotes;
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      this.cases
        .map((c) => c.subCases)
        .flat()
        .every((item) => !item.isApplicable || item.isPassed);
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return this.cases
      .map((c) => c.subCases)
      .flat()
      .map((item) => item.getNotes())
      .flat();
  }

  removeNonApplicable?(): void {
    this.cases = this.cases.filter((c) => c.isApplicable);

    this.cases.forEach((c) => {
      const caseTitles = c.subCases.filter((sc) => sc.isTitle);

      c.subCases = c.subCases.filter((sc) => {
        const parents = caseTitles.filter((t) =>
          (sc.section + '.').startsWith(t.section + '.')
        );

        return (
          (sc.isApplicable && parents.every((p) => p.isApplicable)) ||
          sc.notes.length > 0
        );
      });
    });
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.cases.forEach((c) => {
      c.setAsApplicable();
      c.subCases
        ?.filter((sc) => sc.isTitle)
        ?.forEach((sc) => sc.setAsApplicable());
    });
  }

  getCases(): Cases[] {
    return [
      {
        title: this.title,
        cases: this.cases
      }
    ];
  }
}
